import type { ILocalizedText, IOverrideOption, Lang } from '@platform/core/types';

/**
 * Варіанти поля вибору з рядка «через кому» (прототип v4 optRaw): збіг із підписом чи значенням наявного варіанта — той самий варіант;
 * інакше — перейменування варіанта на тій самій позиції (значення зберігається, записи не губляться), якщо його ще не використано; решта —
 * нові варіанти зі значенням = текст. Підпис записується мовою інтерфейсу лише для перейменованих і нових. Чиста функція.
 */
export function optionsFromText(text: string, current: ReadonlyArray<{ value: string; label: string }>, lang: Lang): IOverrideOption[] {
  const items = text.split(',').map((s) => s.trim()).filter(Boolean);
  const used = new Set<string>();
  const exact = items.map((item) => {
    const hit = current.find((o) => !used.has(o.value) && (o.label === item || o.value === item));
    if (hit) used.add(hit.value);
    return hit;
  });
  const out: IOverrideOption[] = [];
  items.forEach((item, i) => {
    const hit = exact[i];
    if (hit) { out.push(hit.label === item ? { value: hit.value } : { value: hit.value, label: { [lang]: item } as unknown as ILocalizedText }); return; }
    const renamed = current[i] && !used.has(current[i]!.value) && !items.includes(current[i]!.value) ? current[i] : undefined;
    if (renamed) { used.add(renamed.value); out.push({ value: renamed.value, label: { [lang]: item } as unknown as ILocalizedText }); return; }
    if (!out.some((o) => o.value === item)) out.push({ value: item, label: { [lang]: item } as unknown as ILocalizedText });
  });
  return out;
}
